import React from 'react';
import { useRoboticMowersLoader } from '../../hooks/use-robotic-mowers-loader';
import { useRoboticMowersMissionsProgressTracker } from '../../hooks/use-robotic-mowers-missions-progress-tracker';

export const ActivityTracker = () => {
  useRoboticMowersLoader();
  useRoboticMowersMissionsProgressTracker();
  return <></>;
};

export default ActivityTracker;
